import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { CommonService } from "../../../services/common.service";
import { BaseComponent } from "../../../pages/base.component";
import { environment } from "../.././../../environments/environment";

@Component({
  selector: "app-learners-list",
  templateUrl: "./learners-list.component.html",
  styleUrls: ["./learners-list.component.css"],
})
export class LearnersListComponent extends BaseComponent implements OnInit {
  table: Array<any> = [];
  rId: string = "";
  roles: Array<any> = [];
  tId: string = "";
  roleId: any = localStorage.getItem("RoleId");
  institutions: Array<any> = [];
  headingName: any = {};
  labelName: any = {};
  workItemId: any;
  tableData: boolean = false;
  schools: Array<any> = [];
  departmentDrp: boolean = false;
  schoolDrp: boolean = false;
  departments: Array<any> = [];
  USERID: any;
  getData: any;
  USER_ID: any;
  COURSE_ID: any;
  userDetails: any;
  selectedType: string;
  checkboxValue: boolean = false;
  constructor(
    public CommonService: CommonService,
    private active: ActivatedRoute,
    public toastr: ToastrService,
    private route: Router,
  ) {
    // this.getRoles();
    super(CommonService, toastr);
    // this.roleId = atob(this.roleId);
    this.CommonService.decrypt$(localStorage.getItem("RoleId")).subscribe(
      (value) => {
        this.roleId = value;
      },
    );
    this.active.params.subscribe((res) => {
      this.workItemId = res.id;
    });
  }
  ngOnInit(): void {
    this.myForm = this.formBuilder.group({
      // DEFAULTROLE_ID: ['', Validators.required],
      // USER_ID: ['', Validators.required],
      TYPE: ["", Validators.required],
      DEPARTMENT_ID: [""],
      CATEGORY_ID: [""],
    });
    this.getTennates();
    // this.loadHeadings();
    // this.loadlabels();
  }
  activeSpinner() {
    this.CommonService.activateSpinner();
  }

  deactivateSpinner() {
    this.CommonService.deactivateSpinner();
  }

  loadlabels() {
    this.labelName = {};
    this.CommonService.getCall(
      `TenantRegistration/GetLabelValuesByTaskid/${
        this.workItemId
      }/${localStorage.getItem("TenantCode")}`,
    ).subscribe((res: any) => {
      this.labelName = res;
    });
  }

  loadHeadings() {
    this.headingName = {};
    this.CommonService.getCall(
      `EmsDynamicheadingLables/GetLabelValuesByTaskid/${
        this.workItemId
      }/${localStorage.getItem("TenantCode")}`,
    ).subscribe((res: any) => {
      this.headingName = res;
    });
  }

  changeLearners(tntCode) {
    this.getRoles(tntCode);
  }
  edit(item) {
    let id = item.USERID;
    this.activeSpinner();
    this.CommonService.postCall("EditRegistrationByUserId", {
      CREATEDBY: id,
    }).subscribe(
      (res: any) => {
        this.deactivateSpinner();
        if (this.rId == "3") {
          this.route.navigate(["HOME/components/kemisRegForm"], {
            queryParams: {
              rId: 1,
              uId: id,
            },
          });
          localStorage.setItem("cID", item.COURSEID);
        } else {
          localStorage.setItem("selectedRId", this.rId);
          this.route.navigate(["HOME/registration/editUserRegistration"], {
            queryParams: {
              token: res.value,
              wId: this.workItemId,
              rId: this.rId,
            },
          });
        }
      },
      (err) => {
        this.deactivateSpinner();
      },
    );
  }

  getRoles(tntCode: any) {
    this.activeSpinner();
    this.CommonService.postCall("CallCenter/GetAllLearnersByTnt", {
      TENANTCODE: tntCode,
    }).subscribe(
      (res: any) => {
        this.roles = res;
        // this.change(this.rId, "drpdown");
        this.deactivateSpinner();
      },
      (error) => {
        this.deactivateSpinner();
      },
    );
  }
  getTennates() {
    this.activeSpinner();
    // this.CommonService.postCall('GetTenantByRoleId',{RoleId:this.roleId}).subscribe(
    this.CommonService.postCall("CallCenter/GetAllInstitutions", {
      TNT_PARENT_CODE: localStorage.getItem("TenantCode"),
    }).subscribe(
      (res) => {
        this.institutions = res?.data;
        this.deactivateSpinner();
      },
      (err) => {
        this.deactivateSpinner();
      },
    );
  }
  add() {
    // this.route.navigate(["/HOME/components/kemisRegForm"], {
    //   queryParams: { type: "add", rId: 1 },
    // });
    if (this.rId == "3") {
      return this.route.navigate(["/HOME/components/kemisRegForm"], {
        // queryParams: { rId: 1 },
        queryParams: { type: "add", rId: 1 },
      });
    } else {
      let payLoad = {
        TENANT_CODE: this.tId || localStorage.getItem("TenantCode"),
        CREATEDBY: localStorage.getItem("UserId"),
        RoleId: this.rId,
      };
      this.activeSpinner();
      this.CommonService.postCall("AddRegistration", payLoad).subscribe(
        (res) => {
          this.deactivateSpinner();
          let params = {
            tcode: this.tId || this.TenantCode,
            uType: res.UserType,
            rId: res.RoleId,
            token: res.VerificationToken && res.VerificationToken[0],
            wId: this.workItemId,
          };
          this.route.navigate(["/HOME/registration/addUserRegistration"], {
            queryParams: params,
          });
        },
        (err) => {
          this.deactivateSpinner();
          this.toastr.warning(err.error);
        },
      );
    }
  }
  assignPrivilages(obj: any) {
    this.USERID = obj.USERID;
    let payload = {
      TNT_CODE: this.TenantCode,
      USER_ID: obj.USERID,
    };
    this.CommonService.postCall(
      "RolePermissions/GetListByUser",
      payload,
    ).subscribe((res: any) => {
      this.getData = res;
      setTimeout(() => {
        this.myForm.patchValue({
          TYPE: res.TYPE,
        });
        this.getDeporSchool(res.TYPE);
        this.getDepartments(res.CATEGORY_ID);
      }, 500);
    });
    // this.route.navigate(['/HOME/registration/rolePermissions/4'], { queryParams: { uId: obj.USERID, rId: this.rId } })
  }
  getDepartments(event: any) {
    this.departments = [];
    this.activeSpinner();
    this.CommonService.postCall("Department/GetListDeptByCategory", {
      COURSE_CATEGORY_ID: event,
      TNT_CODE: this.TenantCode,
    }).subscribe((res: any) => {
      this.departments = res;
      this.myForm.patchValue({
        DEPARTMENT_ID: this.getData?.DEPARTMENT_ID,
      });
      this.deactivateSpinner();
    });
  }
  getDeporSchool(event: any) {
    if (event == 1) {
      this.departmentDrp = true;
      this.schoolDrp = true;
      // this.schoolDrp = false;
      this.departments = [];
      this.activeSpinner();
      // this.CommonService.postCall('Department/dropdown', { "TNT_CODE": this.TenantCode }).subscribe((res: any) => {
      //   this.departments = res;
      //   setTimeout(() => {
      //     this.myForm.patchValue({
      //       "DEPARTMENT_ID": this.getData?.DEPARTMENT_ID
      //     })
      //   }, 500);

      //   this.deactivateSpinner();
      // })
      this.schoolDropdowns();
      this.deactivateSpinner();
    } else if (event == 2) {
      this.departmentDrp = false;
      this.schoolDrp = true;
      this.schoolDropdowns();
    } else {
      this.departmentDrp = false;
      this.schoolDrp = false;
    }
  }
  schoolDropdowns() {
    this.schools = [];
    this.activeSpinner();
    this.CommonService.postCall("CourseCategory/GetCourseCategory", {
      TENANT_CODE: this.TenantCode,
    }).subscribe((res: any) => {
      this.schools = res;
      setTimeout(() => {
        this.myForm.patchValue({
          CATEGORY_ID: this.getData?.CATEGORY_ID,
        });
      }, 500);

      this.deactivateSpinner();
    });
    this.deactivateSpinner();
  }
  onSubmit(form: FormGroup) {
    this.activeSpinner();
    let value = form.value;
    value.USERINROLE_ID = this.rId;
    value.TNT_CODE = this.TenantCode;
    value.CREATED_BY = this.userId;
    value.MODIFIED_BY = this.userId;
    value.DEFAULTROLE_ID = this.rId;
    value.USER_ID = this.USERID;
    if (value.TYPE == "1") {
      value.DEPARTMENT_ID == ""
        ? this.toastr.warning("Department is mandatory!")
        : value.DEPARTMENT_ID;
      // value.CATEGORY_ID = '0'
    } else if (value.TYPE == "2") {
      value.CATEGORY_ID == ""
        ? this.toastr.warning("School is mandatory!")
        : value.CATEGORY_ID;
      value.DEPARTMENT_ID = "0";
    } else {
      value.CATEGORY_ID = "0";
      value.DEPARTMENT_ID = "0";
    }
    // if (this.isEdit) {
    //   this.CommonService.postCall('RolePermissions/Update', value).subscribe((res: any) => {
    //     document.getElementById('md_close')?.click();
    //     this.toastr.success(res.message);
    //     // this.getList();
    //     this.deactivateSpinner();
    //   }, (err: any) => {
    //     this.toastr.error(err.error.message);
    //     this.deactivateSpinner();
    //   })
    // } else {
    value["ROLEPERMISSION_ID"] =
      this.getData.message == "No Records"
        ? 0
        : this.getData?.ROLEPERMISSION_ID;
    this.CommonService.postCall("RolePermissions/Create", value).subscribe(
      (res: any) => {
        document.getElementById("md_close")?.click();
        this.toastr.success(res.message);
        // this.getList();
        this.deactivateSpinner();
      },
      (err: any) => {
        this.toastr.error(err.error.message);
        this.deactivateSpinner();
      },
    );
    // }
  }

  close() {
    this.myForm.reset();
    this.getData = {};
  }
  routeToAssignRoles(obj) {
    localStorage.setItem("selctedUsername", obj.USERNAME);
    localStorage.setItem("selectedName", obj.FIRSTNAME);
    this.route.navigate(["/HOME/registration/assignMultislectRoles"], {
      queryParams: { uId: obj?.USERID, rId: this.rId },
    });
  }
  viewApplicationForm(obj: any) {
    this.activeSpinner();
    this.USER_ID = obj.USERID;
    this.COURSE_ID = obj.COURSEID;
    this.CommonService.postCall("Registration/GetAudioPath", {
      USERID: obj.USERID,
      COURSE_ID: obj.COURSE_ID,
    }).subscribe(
      (res: any) => {
        this.userDetails = res;
        this.deactivateSpinner();
      },
      (err: any) => {
        this.deactivateSpinner();
      },
    );
  }

  downloadForm() {
    let payload = {
      USERID: this.USER_ID,
      file_name: "ApplicationForm.jrxml",
      file_type: "pdf",
      token: localStorage.getItem("tkn"),
      COURSE_ID: this.COURSE_ID,
    };
    this.activeSpinner();
    this.CommonService.reportAPi(payload).subscribe(
      (res: any) => {
        const urlSegments = res.data.viewPath.split("/");
        const fileName = urlSegments[urlSegments.length - 1];
        const a = document.createElement("a");
        a.href = environment.downloadReportUrl + fileName;
        a.download = "Application Form.pdf"; // Specify the desired file name
        a.style.display = "none"; // Hide the anchor element
        document.body.appendChild(a); // Append to the DOM
        a.click(); // Trigger the download
        document.body.removeChild(a);
        document.getElementById("Closemodal")?.click();
        this.deactivateSpinner();
      },
      (err: any) => {
        this.deactivateSpinner();
      },
    );
    this.deactivateSpinner();
  }
  tansfer() {
    this.route.navigate(["/HOME/registration/schoolTransfer"]);
  }
}
